import { render, staticRenderFns } from "./teamDirverAdd.vue?vue&type=template&id=54bc8cea&scoped=true"
import script from "./teamDirverAdd.vue?vue&type=script&lang=js"
export * from "./teamDirverAdd.vue?vue&type=script&lang=js"
import style0 from "./teamDirverAdd.vue?vue&type=style&index=0&id=54bc8cea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bc8cea",
  null
  
)

export default component.exports